module.exports = __webpack_public_path__ + "img/nasil_hs.ed5a717a.svg";